import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import { ListDivider } from 'rmwc/List';
import {TextField} from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Select } from 'rmwc/Select';
import StatusMessage from '../../util/StatusMessage'
import { Radio, Checkbox } from 'rmwc/Radio';

class UserDetailSearch extends Component {

  constructor(props){
    super(props);
    this.state={
      data:{
        criteria: 'phone',
        searchTerm:'',
        userDetails: '',
        userErrMsg: '',
        noCouponMsg: '',
        phoneNumberStatus: ''
      },
      componentToShow: true,
      errorMsg: '',
    }
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  handleSearchCriteriaChange = (e) => {
    let data = Object.assign({}, this.state.data)
    data.criteria = e.target.value
    this.setState({data: data})
  }

  handleSearchQuery = (e) => {

    e.preventDefault()
    this.fetchSearchResults()
    
  }

  handleClear = (e) => {
    e.preventDefault()
    const data = Object.assign({}, this.state.data);
    data.searchTerm =''
    data.userDetails = ''
    data.userErrMsg = ''
    this.setState({data:data,componentToShow: true,errorMsg: ''})
    
  }

  fetchSearchResults = () => {
    let data = Object.assign({}, this.state.data)
    if(data.searchTerm === ''){
      data.userDetails = ''
      data.userErrMsg= ''
      this.setState({errorMsg: 'Please enter the search term', data: data})
      return
    }
    if(data.criteria === 'phone'){
      if(data.searchTerm.length < 10){
        return this.setState({errorMsg: 'Please provide valid phone number'})
      }
    }
    let errorMsg = ''
     let apiInput = {
        'type': data.criteria,
        'search_key': data.searchTerm,
      }
    api.searchUsers(this.props.user.accessToken, apiInput).then((result) => {
      const { status, errors} = result
      if (status === 'success') {
        if(result.data) {
          data.userDetails = result.data
          data.phoneNumberStatus = result.data.user_message
        }
        else if (result.message){
          data.userDetails = ''
          data.userErrMsg = result.message
        }
      }
      else if(result.status === 'error'){
        data.userDetails = ''
        data.noCouponMsg = result.message
      }
      this.setState({data:data, errorMsg: errorMsg})
    })
    .catch((err) => {
      this.setState({ errorMsg: 'Error in Fetching Details' })
    })
  } 

  handleDisplay = () => {
    this.setState({componentToShow: false})
  }

  handleRedirectionAfterSave = () => {
    this.props.history.push('/portal/app/institute/userdetail_list')
  }

   handleBack = () => {
    this.setState({componentToShow:true})
  }

  render() {
    let searchComponent,displayComponent;
    searchComponent = (
      <div>
        <Select 
          onChange={this.handleSearchCriteriaChange} 
          value={this.state.data.criteria}
          className="admin-reg-filter-section" 
        >
          <option value="phone">Phone Number</option>
        </Select>
        <TextField  className='admin-reg-filter-criteria' label="Search Term" autoComplete="off" name="searchTerm" onChange={this.onInputChange} value={this.state.data.searchTerm}/>
        <Button className="add-opportunity" onClick={this.handleSearchQuery}>
          Search
        </Button>
        <Button className="add-opportunity" onClick={this.handleClear}>
          Clear
        </Button>
        <br/><br/>
      </div>
    )

    let user;
    if(this.state.data.userDetails !== ''){
      user = this.state.data.userDetails
      displayComponent = (
        <div>
          <Grid>
            <GridCell span="12" align="left">
              <Typography><b>This phone number is already registered with MyCENTA.</b></Typography>
            </GridCell>
            <GridCell span="12" align="left">
              <p style={{color: 'red'}}>{this.state.data.phoneNumberStatus}</p>
            </GridCell>
            <GridCell span="12">
              <Button onClick={this.handleDisplay}>Register</Button>
            </GridCell>
          </Grid>
        </div>
      )
    }
    else if(this.state.data.userErrMsg) {
      displayComponent = (
        <div>
          <StatusMessage error_msg = {this.state.data.userErrMsg}/>
          <Button onClick={this.handleDisplay}>Register</Button>
        </div>
      )
    }
    else if(this.state.data.noCouponMsg) {
      displayComponent = (
        <div>
          <StatusMessage error_msg = {this.state.data.noCouponMsg}/>
        </div>
      )
    }

    let componentToShow;
    if(this.state.componentToShow) {
      componentToShow = (
        <div>
          <Card style={{padding: '25px'}}><Typography use="body1">User Detail Search </Typography> </Card>
          {searchComponent}
          <Card>{displayComponent}</Card>
        </div>
      )
    }
    else{
      componentToShow = (<InstitutionalTQRegistration userDetails = {this.state.data.userDetails} accessToken = {this.props.user.accessToken} handleRedriect={this.handleRedirectionAfterSave} onHandleBack={this.handleBack}/>)
    }

    return (
      <div>
        {componentToShow}
        <StatusMessage error_msg = {this.state.errorMsg}/>
      </div>
    );
  }
}

class InstitutionalTQRegistration extends Component {

  constructor(props){
    super(props);
    this.state={
      data: {
       firstName: '',
       lastName: '',
       phone: '',
       email: '',
       tqTestTrack: [],
       tqTestTrackId: '',
       tqType: [],
       tqTypeId: '',
       tqTypeName: '',
       genderId: '',
       groupInstitutionsList: [],
       groupInstitutionId: '',
       groupInsitutionName: '',
       totalCouponCount: '',
       totalCountError: ''
      },
      formErrors: {
        'firstNameError':'',
        'lastNameError':'',
        'emailError': '',
        'phoneError': '',
        'genderError': '',
        'testTrackError': '',
        phoneLenError: '',
      },
      errorMsg: '',
      buttonDisable: true
    }
  }

  componentDidMount() {
    const data = Object.assign({}, this.state.data);
    data.firstName = this.props.userDetails.first_name
    data.lastName = this.props.userDetails.last_name
    data.phone = this.props.userDetails.phone
    if(this.props.userDetails.email === 'no'){
      data.email = ''
    }
    else if (this.props.userDetails.email === 'yes'){
      data.email = this.props.userDetails.email
    }
    data.genderId = this.props.userDetails.gender

    return api.getTQTestTracks(this.props.accessToken)
      .then((result) => {
        data.tqTestTrack = result
        return api.getTqTypes(this.props.accessToken)
        }).then((result) =>{
          data.tqType = result.data
          data.tqTypeId = result.data[0].id
         return api.getGroupInstitutionList(this.props.accessToken)
        }).then((result) =>{
          data.groupInstitutionsList = result.data
          this.setState({data: data})
        })
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  }

  handleTestTrackChange = (event) =>{
    let data = Object.assign({}, this.state.data)
    this.setState({errorMsg: ''})
    if(event.target.value){
      let selectedOption = event.target.value
      data.tqTestTrackId = selectedOption
      var optionElement = event.target.childNodes[event.target.selectedIndex]
    }
    else{
      data.tqTestTrackId = ''
    }
    this.setState({data: data})
  }

  handleSubmit = (e, registration) =>{
    e.preventDefault()
    if(registration === 'old') {
    this.processRegistration(false)
    }
    else if(registration === 'new') {
      this.handleNewRegistration(false)
    }
  }

  validateForm(){

    let error = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)
    const validEmail = (new RegExp(/(?!\.)(?!.*\.$)(?!.*?\.\.)[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(data.email))

    errorObj.firstNameError = ''
    errorObj.lastNameError = ''
    errorObj.emailError = ''
    errorObj.phoneError = ''
    errorObj.testTrackError =''
    errorObj.genderError = ''
    errorObj.phoneLenError = ''


    if(data.firstName === '' || data.firstName === undefined){
        errorObj.firstNameError ='First Name is mandatory'
        error = false
      }

      if(data.lastName === '' || data.lastName === undefined){
        errorObj.lastNameError ='Last Name is mandatory'
        error = false
      }
      if((this.props.userDetails === '') || (this.props.userDetails.email === 'no') || (this.props.userDetails === undefined)){
        if(!(data.email) || (data.email === '') || (validEmail === false)){
          errorObj.emailError ='Please enter the valid email'
          error = false
        }
      }

      if((this.props.userDetails === '') || (this.props.userDetails === undefined)) {
        if(!(data.phone) || data.phone === '' || data.phone === undefined){
          errorObj.phoneError ='Phone is mandatory'
          error = false
        }

        if(data.phone !== undefined) {
          if(data.phone.length !== 12){
            errorObj.phoneLenError = 'Please enter the phone number with country code.'
            error = false
          }
        }
      }

      if(!(data.genderId) || data.genderId === ''){
        errorObj.genderError ='Gender is mandatory'
        error = false
      }

      if(!(data.tqTestTrackId) || data.tqTestTrackId === ''){
        errorObj.testTrackError ='Please select the test track'
        error = false
      }

      this.setState({
        formErrors:errorObj,
        errorMsg:'',
      })
      return error
  }

  processRegistration = (isPayment) => {
    let data = Object.assign({}, this.state.data)
    let emailCheck = this.props.userDetails.email
    let userApiInput = {}
    if(emailCheck === 'yes') {
      userApiInput['phone'] = data.phone 
    }
    else if (emailCheck === 'no') {
      userApiInput['email'] = data.email
    }
    if(this.validateForm()){
      let apiInput = {
        'user_id': this.props.userDetails.id,
       'certification_participation': {
        'certification_type_id': '4',    
        },      
        'tq_certification': {
        'global_type_id': data.tqTypeId,
        'institution_id': data.groupInstitutionId
        },      
        'payment': {
          'payment_mode_id': "1",
          'currency': 'RS'
        },      
        'tq_certification_detail': {
          'tq_test_track_id': data.tqTestTrackId,
        },
        'user': userApiInput,
        'personal_info':{
          'first_name': data.firstName,
          'last_name': data.lastName,
          'gender_id': data.genderId
        },
        'payment_option':{
          'is_payment': isPayment
        },
      }

      this.setState({buttonDisable: true})
       api.saveTqCertifications(this.props.accessToken,apiInput)
      .then((result) => {     
        if(result.status === 'error'){
          this.setState({ errorMsg: result.message, buttonDisable: false })
        }
        else if(result.errors) {
          this.setState({errorMsg: result.errors[0], buttonDisable: false})
        }
        else if(result.status === 'success'){
          this.setState({errorMsg: result.message, buttonDisable: true})
          this.props.handleRedriect();
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack, buttonDisable: false })
      })
    }
  }

  handleNewRegistration = (isPayment) => {
    let data = Object.assign({}, this.state.data)

    if(this.validateForm()) {
      let apiInput = {  
        'tq_certification': {
        'global_type_id': data.tqTypeId,
        'institution_id': data.groupInstitutionId
        },      
        'payment': {
          'payment_mode_id': "1",
          'currency': 'RS'
        },      
        'tq_certification_detail': {
          'tq_test_track_id': data.tqTestTrackId,
        },
        'user':{
          'email': data.email,
          'phone': data.phone,
          'password': data.phone,
          'password_confirmation': data.phone,
          'user_name': data.phone,
        },
        'certification_participation':{
          'certification_type_id': "4"
        },
        'tq_certification_detail':{
          'tq_test_track_id': data.tqTestTrackId
        },
        'personal_info':{
          'first_name': data.firstName,
          'last_name': data.lastName,
          'gender_id': data.genderId
        },
        'payment_option':{
          'is_payment': isPayment
        },
    }
    this.setState({buttonDisable: true})
    api.saveInstitutionalTqRegistration(this.props.accessToken, apiInput)
      .then((result) => {     
        if(result.status === 'error') {
          this.setState({ errorMsg: result.message, buttonDisable: false })
        }
        else if(result.errors) {
          this.setState({errorMsg: result.errors[0], buttonDisable: false})
        }
        else if(result.status === 'success'){
          this.setState({errorMsg: result.message, buttonDisable: true})
          this.props.handleRedriect();
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack, buttonDisable: false})
      })
    }
  }

  handletqTypeChange = (event) => {
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    let data = Object.assign({}, this.state.data)
    data.tqTypeId = event.target.value
    data.tqTypeName = optionElement.getAttribute('data-name')
    this.setState({data: data})
  }

  handleInstituteChange = (event) => {
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    let data = Object.assign({}, this.state.data)
    data.groupInstitutionId = event.target.value
    data.groupInsitutionName = optionElement.getAttribute('data-name')
    if(data.groupInstitutionId) {
      api.getCouponDetailsForInstitution(this.props.accessToken, data.groupInstitutionId)
      .then((result) => {     
        if (result.status === 'success') {
          if(result.data === null ) {
            data.totalCouponCount = ''
            data.totalCountError = 'This institution is not allocated with any coupon yet'
            this.setState({buttonDisable: true, data: data, errorMsg: ''})
          }
          else if(result.data !== null ) {
            if(result.data.remaining_count > 0) {
              data.totalCouponCount = result.data.remaining_count
              data.totalCountError = ''
              this.setState({data: data, buttonDisable: false, errorMsg: ''})
            }
            else {
              data.totalCountError = 'This Institution has no remaining coupons'
              data.totalCouponCount = ''
              this.setState({buttonDisable: true, data: data, errorMsg: ''})
            }
          }
        }
        else if(result.status === 'error'){
          this.setState({ errorMsg: result.errors })
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
    }
  }
  
  handleBack = (e) => {
    e.preventDefault();
    this.props.onHandleBack()
  }

  render(){
    let tqTypeComponent

    tqTypeComponent = (
      <div className="full-width">
        <div className="mdc-select" role="listbox">
          <select
            name="type"
            onChange={this.handletqTypeChange}
            value={this.state.data.tqTypeId}
            className="mdc-select__native-control two-col-input">
            {this.state.data.tqType.map(function(tqTypes){
                return(<option key={tqTypes.id} value={tqTypes.id} data-name={tqTypes.name}>
                  {tqTypes.name} 
                </option>)
            })}
          </select>
          <label className="mdc-floating-label mdc-floating-label--float-above">Type</label>
          <div className="mdc-line-ripple"></div>
        </div>
      </div>
    )

    let registration, phoneNumberDisable, emailHidden, firstNameDisable, lastNameDisable;
    if(this.props.userDetails === '' || this.props.userDetails === undefined) {
      registration = 'new'
      phoneNumberDisable = false
      firstNameDisable = false
      lastNameDisable = false
    } else {
      registration = 'old'
      phoneNumberDisable = true

      if((this.props.userDetails.first_name === '') || (this.props.userDetails.first_name === null) || (this.props.userDetails.first_name === undefined)){
        firstNameDisable = false
      }
      else{
        firstNameDisable = true
      }

      if((this.props.userDetails.last_name === '') || (this.props.userDetails.last_name === null) || (this.props.userDetails.last_name === undefined)){
        lastNameDisable = false
      }
      else{
        lastNameDisable = true
      }
    }

    if(this.props.userDetails.email === 'yes'){
      emailHidden = true
    }
    else if(this.props.userDetails.email === 'no'){
      emailHidden = false
    }

    let institutionComponent;

    institutionComponent = (
      <div className="full-width">
        <div className="mdc-select" role="listbox">
          <select
            name="type"
            onChange={this.handleInstituteChange}
            value={this.state.data.groupInstitutionId}
            className="mdc-select__native-control two-col-input">
            <option value="" selected="">--Select the Institution--</option>
            {this.state.data.groupInstitutionsList.map(function(institute){
                return(<option key={institute.id} value={institute.id} data-name={institute.name}>
                  {institute.name} 
                </option>)
            })}
          </select>
          <label className="mdc-floating-label mdc-floating-label--float-above">Institution Name</label>
          <div className="mdc-line-ripple"></div>
        </div>
      </div>
    )

    let remainingCouponMsg = 'This Institution has ' + this.state.data.totalCouponCount + ' remaining coupons';
    return (
      <form onSubmit={(e) => this.handleSubmit(e, registration)} style={{width: '100%'}}>
        <Card style={{padding: '25px'}}>

          <Grid className="opportunity-list-item">

            <GridCell span="8">
              <Typography use="headline5">Teaching Quotient Registration</Typography>
            </GridCell>
            <GridCell span="4">
              <Button raised onClick={(e) => this.handleBack(e)}>Back</Button>
            </GridCell>
            
            <GridCell span="6">
              <TextField fullwidth className='text_input' disabled={firstNameDisable} label="First Name" autoComplete="off" name="firstName" onChange={this.onInputChange} value={this.state.data.firstName}/>
            </GridCell>
            <GridCell span="6"></GridCell>
            
            <GridCell span="6">                  
              <TextField fullwidth className='text_input' disabled={lastNameDisable} label="Last Name" autoComplete="off"  name="lastName" onChange={this.onInputChange} value={this.state.data.lastName}/>
            </GridCell>
            <GridCell span="6"></GridCell>
            <GridCell span="6">
              <div>
              Gender:
              <Radio 
                name="genderId"
                value="1"
                checked={this.state.data.genderId == '1'}
                onChange={this.onInputChange}>
                Male
              </Radio>
              <Radio
                name="genderId"
                value="2"
                checked={this.state.data.genderId == '2'}
                onChange={this.onInputChange}>
                Female
              </Radio>
              <Radio
                name="genderId"
                value="3"
                checked={this.state.data.genderId == '3'}
                onChange={this.onInputChange}>
                Other
              </Radio>
            </div>
            </GridCell>
            <GridCell span="6"></GridCell>
            <GridCell span="6">
              <TextField fullwidth type = "number" disabled={phoneNumberDisable} className='text_input' label="Phone Number" autoComplete="off"  name="phone" onChange={this.onInputChange} value={this.state.data.phone}/>
            </GridCell>
            <GridCell span="6"></GridCell>

            <GridCell span="6" hidden={emailHidden}>
              <TextField fullwidth className='text_input' label="Email" autoComplete="off"  name="email" onChange={this.onInputChange} value={this.state.data.email}/>
            </GridCell>
            <GridCell span="6" hidden={emailHidden}></GridCell>
            <GridCell span="6">
              {institutionComponent}
            </GridCell>
            <GridCell span="6"/>
            <GridCell span="6">
              {tqTypeComponent}
            </GridCell>
            <GridCell span="6"/>
            <GridCell span="6">
              <div className="full-width">
                <div className="mdc-select" role="listbox">
                  <select 
                    name="testcenter"
                    onChange={this.handleTestTrackChange}
                    value={this.state.data.tqTestTrackId}
                    className="mdc-select__native-control two-col-input"
                  >
                    <option value="" selected="">--Select Test Track--</option>
                    {this.state.data.tqTestTrack.map(testTrack => (
                      <option key={testTrack.id} value={testTrack.id} data-name={testTrack.name} track-amount={testTrack.amount}>
                        {testTrack.name} 
                      </option>
                    ))}
                  </select>
                  <label className="mdc-floating-label mdc-floating-label--float-above">Test Track</label>
                  <div className="mdc-line-ripple"></div>
                </div>
              </div>
            </GridCell>
            <GridCell span="6"></GridCell>
            <GridCell span="6">
              <Button raised disabled={this.state.buttonDisable}>Register</Button>
            </GridCell> 
          </Grid>
          <StatusMessage error_msg = {this.state.errorMsg}/>
          <StatusMessage error_msg = {this.state.formErrors.firstNameError}/>
          <StatusMessage error_msg = {this.state.formErrors.lastNameError}/>
          <StatusMessage error_msg = {this.state.formErrors.emailError}/>
          <StatusMessage error_msg = {this.state.formErrors.phoneError}/>
          <StatusMessage error_msg = {this.state.formErrors.genderError}/>
          <StatusMessage error_msg = {this.state.formErrors.testTrackError}/>
          <StatusMessage error_msg = {this.state.data.totalCountError}/>
          <StatusMessage error_msg = {this.state.formErrors.phoneLenError}/>
          {this.state.data.totalCouponCount !== '' ? <StatusMessage error_msg = {remainingCouponMsg}/> : null}
        </Card>
      </form>
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDetailSearch);


// WEBPACK FOOTER //
// ./src/views/PartialTQ/UserDetailSearch.jsx